<div *ngIf="(landoltValues$ | async) as values"
		class="center-content"
>
	<div *ngIf="(alternativeEingabe$ | async) === false" nz-row class="landolt-block">
		<div *ngFor="let element of landoltElements, let i = index" nz-col class="landolt twenty-span">
			<div class="landolt-button"
					[ngClass]="[
						values.selected[i] && element.value === 0 ? 'selected-true' : '',
						!values.selected[i] && element.value === 0 ? 'selected-false' : ''
					]"
			>
				<img *ngIf="element.value === 0" src="assets/images/icons/landolt_C_slim_u.svg" alt="U"/>
				<img *ngIf="element.value === 1" src="assets/images/icons/landolt_C_slim_r.svg" alt="C"/>
				<img *ngIf="element.value === 2" src="assets/images/icons/landolt_C_slim_d.svg" alt="&cap;"/>
				<img *ngIf="element.value === 3" src="assets/images/icons/landolt_C_slim_l.svg" alt="&#390;"/>
			</div>
		</div>
	</div>
	<div [ngClass]="{'right-bound': (alternativeEingabe$ | async) === false}">
		<div *ngIf="(alternativeEingabe$ | async) === true">
			{{'workflow.test.completed' | translate}}
		</div>
		<table class="big-text markdown-html">
			<tbody>
				<tr>
					<td class="left-align">{{ 'word.time' | translate }}</td>
					<td class="center-align cell-padding">:</td>
					<td class="right-align cell-padding">{{ values.zeit | number: '1.2-2': language }} sek</td>
				</tr>
				<tr>
					<td class="left-align">{{ 'word.error' | translate }}</td>
					<td class="center-align cell-padding">:</td>
					<td class="right-align cell-padding">{{ values.fehler }}</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>
